import { YesNoScreen } from './yesnoScreen';
import { HandoverFlowNotice } from '../../customNotice/botNotice/handoverFlowNotice';
import { ScreenChangeNotice } from '../../customNotice/clientNotice/screenChangeNotice';
import { TrackingNotice } from '../../customNotice/botNotice/trackingNotice';
export class HandoverOfferScreen extends YesNoScreen {
    constructor(uic) {
        super("handoverOffer", uic);
        this.elements = {};
    }
    show(options) {
        this.elements['mainDiv'].show();
        this.uic.widgetHeaderController.enableEndChatOnCloseButton();
    }
    hide() {
        this.elements['mainDiv'].hide();
    }
    bootstrapScreen(chatWindowElement) {
        super.bootstrapScreen(chatWindowElement);
        this.setupElements();
    }
    resizeEvent() {
    }
    setupElements() {
        let i18n = this.uic.configuration.i18n;
        this.elements['text1'].html("Dein Anliegen soll natürlich gelöst werden.");
        this.elements['text2'].html("Möchtest du noch mit einem A1 Serviceberater chatten?");
        this.elements['text3'].html("Du wirst im Anschluss wieder in den Chat geleitet.");
        if (i18n) {
            if (i18n.handoverOfferScreenText1) {
                this.elements['text1'].html(i18n.handoverOfferScreenText1);
            }
            if (i18n.handoverOfferScreenText2) {
                this.elements['text2'].html(i18n.handoverOfferScreenText2);
            }
            if (i18n.handoverOfferScreenText3) {
                this.elements['text3'].html(i18n.handoverOfferScreenText3);
            }
        }
        this.elements['btnYes'].click(() => {
            this.uic.widget.sendCustomNotice(new TrackingNotice("chat", "Feedback_ho_screen_positive", "Feedback_ho_screen_positive"));
            this.uic.widget.sendCustomNotice(new HandoverFlowNotice(true));
            this.uic.showScreen("chat");
            this.uic.chatScreen.showTyping('bot');
            this.uic.widget.sendCustomNotice(new ScreenChangeNotice("chat", this.uic.widget.getWidgetApplicationId()));
        });
        this.elements['btnNo'].click(() => {
            this.uic.widget.track("chat", "chat_ended", "closed");
            let trackingNotice = new TrackingNotice("chat", "Feedback_ho_screen_negative ", "Feedback_ho_screen_negative ");
            this.uic.widget.endChatSession(this.uic.widget.sendCustomNotice(trackingNotice));
        });
        this.elements['close'].click(() => {
            let trackingNotice = new TrackingNotice("chat", "Feedback_ho_screen_close", "Feedback_ho_screen_close");
            this.uic.widget.sendCustomNotice(trackingNotice);
        });
    }
}
